import { cornermarkFragment } from "@saleor/fragments/cornermark";
import { instagramFragment } from "@saleor/fragments/instagram";
import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import { fragmentMoney } from "@saleor/fragments/products";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  InsProductVariantDetails,
  InsProductVariantDetailsVariables
} from "./types/InsProductVariantDetails";
import {
  InstagramDetails,
  InstagramDetailsVariables
} from "./types/InstagramDetails";
import { InstagramList, InstagramListVariables } from "./types/InstagramList";

const instagramList = gql`
  ${pageInfoFragment}
  query InstagramList(
    $filter: InstagramTypeFilterInput
    $before: String
    $after: String
    $first: Int
    $last: Int
    $sort: InstagramSortingInput
  ) {
    instagrams(
      filter: $filter
      before: $before
      after: $after
      first: $first
      last: $last
      sortBy: $sort
    ) {
      totalCount
      edges {
        node {
          id
          instagramId
          image
          imageThumb
          username
          mimeType
          platForm
          url
          likes
          comments
          createTime
          published
          updateTime
          istop
          userpicUrl
          number
          shortcode
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;
export const useInstagramListQuery = makeQuery<
  InstagramList,
  InstagramListVariables
>(instagramList);

const instagramDetails = gql`
  ${instagramFragment}
  query InstagramDetails($id: ID!) {
    instagram(id: $id) {
      ...InstagramFragment
    }
  }
`;
export const useInstagramDetailsQuery = makeQuery<
  InstagramDetails,
  InstagramDetailsVariables
>(instagramDetails);

const insProductVariant = gql`
  ${cornermarkFragment}
  ${fragmentMoney}
  query InsProductVariantDetails($id: ID, $sku: String) {
    productVariant(variantId: $id, sku: $sku) {
      id
      variantId
      sku
      name
      skuName
      urlSlug
      price {
        ...Money
      }
      pricing {
        priceUndiscounted {
          gross {
            ...Money
          }
        }
      }
      attributes {
        values {
          value: name
        }
      }
      product {
        id
        name
        thumbnail {
          url
        }
      }
      margin
      trackInventory
      cornerMark {
        ...CornermarkFragment
      }
    }
  }
`;
export const useInsProductVariantQuery = makeQuery<
  InsProductVariantDetails,
  InsProductVariantDetailsVariables
>(insProductVariant);
